<template>
  <div>
    <el-card v-loading="loading" shadow="hover">
      <div slot="header">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-input
              v-model="username"
              placeholder="请输入员工名称"
              @input="onInput"
            ></el-input>
          </el-col>
          <el-col :span="12" class="vv-text_r">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="onAdd"
              >新建员工</el-button
            >
          </el-col>
        </el-row>
      </div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="username" label="员工名" width="200">
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              effect="dark"
              :type="statusType[scope.row.status - 1]"
            >
              {{ statusVal[scope.row.status - 1] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100"
          header-align="left"
          align="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="onEdit(scope.row.id)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onCurrentChange"
        hide-on-single-page
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-drawer
      :title="title"
      size="25%"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="onClose"
    >
      <staff-form
        ref="staffForm"
        :id="id"
        :show="drawer"
        :type="type"
        @close="formClose"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getStaff } from "@/api/wx-staff";
import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Table,
  TableColumn,
  Pagination,
  Tag,
  Drawer,
} from "element-ui";
import StaffForm from "./form";
export default {
  name: "Staff",
  components: {
    [Card.name]: Card,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Tag.name]: Tag,
    [Drawer.name]: Drawer,
    StaffForm,
  },
  data() {
    return {
      loading: false,
      statusType: ['success','danger'],
      statusVal: ['正常','禁用'],
      username: null,
      tableData: [],
      pagesize: 10,
      total: 0,
      currentPage: 1,
      title: null,
      drawer: false,
      type: null,
      id: 0,
    };
  },
  methods: {
    onInput() {
      this.fetchData();
    },
    onAdd() {
      this.drawer = true;
      this.title = "新建员工";
      this.type = "add";
    },
    onEdit(id) {
      this.id = id;
      this.drawer = true;
      this.title = "编辑员工";
      this.type = "edit";
    },
    onCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      getStaff({
        page_id: this.currentPage,
        page_size: this.pagesize,
        username: this.username,
      })
        .then((rs) => {
          this.tableData = rs.data.data;
          this.total = rs.data.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClose(done) {
      this.$refs["staffForm"].clearFun();
      done();
    },
    formClose(status) {
      this.$refs["staffForm"].clearFun();
      this.drawer = status;
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
